

export const getHomepageSiteHeaderSettings = (siteHeaderSettings, isMobile, isDarkMode) => {
   const screen = isMobile ? 'mobile' : 'desktop'
   // header props from homepage
   const result = {
      hasSiteHeader: false,
      iconColorOverSiteHeader: null,
      dkMenuIconColor: isDarkMode ? 'major-dark' : 'major',
   }

   if(!siteHeaderSettings) {
      return result;
   }

   const mode = siteHeaderSettings?.[`site_header_${ screen }_background_mode`]
   result.hasSiteHeader = Boolean(mode);

   result.iconColorOverSiteHeader = siteHeaderSettings?.site_header_menu_icon_color

   const site_header_show_welcome_text = siteHeaderSettings?.site_header_show_welcome_text
   const site_header_is_bottom_gradient_enabled = siteHeaderSettings?.site_header_is_bottom_gradient_enabled
   const site_header_menu_icon_color = siteHeaderSettings?.site_header_menu_icon_color

   if(!site_header_show_welcome_text && !site_header_is_bottom_gradient_enabled) {
      result.dkMenuIconColor = site_header_menu_icon_color
   }

   return result
}
